
import { createSelector } from "reselect";
import { reducerInit } from '../../api/dbselect.js';

const init = reducerInit('servicepackage', 'sporder')

export const servicePackageReducer = (state = init, action) => {
	switch(action.type) {
		
		case 'INSERT_SERVICEPACKAGE':
			return [...state, action.response[0]]
		
		case 'UPDATE_SERVICEPACKAGE':
		return state.map((object, i) => {
			let newObject = JSON.parse(JSON.stringify(object))
			if (newObject.servicepackageid === action.id) {
				for (const data in action.json) {
					newObject[data] = action.json[data]
				}
				//const sortedObj = newObject.slice().sort((a, b) => a["sporder"] > b["sporder"] ? 1 : -1 )
				return (newObject)
			} else {
				//const sortedObj = newObject.slice().sort((a, b) => a["sporder"] > b["sporder"] ? 1 : -1 )
				return (newObject)
			}
		}).slice().sort((a, b) => a["sporder"] > b["sporder"] ? 1 : -1 )
		
		case 'DELETE_SERVICEPACKAGE':	
		return state.filter(object =>	object.servicepackageid !== action.id)

		default:
		return state
	}
}

export const selectPackagesWithOnlyIds = createSelector(
	(state) => state.servicePackageReducer,
	(packages) => packages.map((spObj) => spObj.servicepackageid)
);

export const selectPackageById = createSelector(
	(state, packageId) => state.servicePackageReducer,
	(_, packageId) => packageId,
	(packages, packageId) => {
		const result = packages.filter(servicePackage => packageId === servicePackage.servicepackageid);
		return result[0];
	}
)
